import type { StartOfWeek } from '@sit/core';
import { useGetEmployeeOvertimeCalculations } from '@sit/openapi';
import { skipToken } from '@tanstack/react-query';
import { useShowOvertime } from '@web/api/users/use-show-overtime';

interface UseOvertimeDiscrepanciesParams {
  employeeId: string | undefined;
  weekStartDate: StartOfWeek<string> | undefined;
  companyId: string | undefined;
  timesheetId: string | undefined;
}

export const useEmployeeOvertimeCalculations = ({ employeeId, weekStartDate, companyId, timesheetId }: UseOvertimeDiscrepanciesParams) => {
  const showOvertime = useShowOvertime({ timesheetId });
  return useGetEmployeeOvertimeCalculations(
    !showOvertime || !companyId || !weekStartDate || !employeeId
      ? skipToken
      : {
          pathParams: {
            employeeId: employeeId,
            week: weekStartDate,
          },
          queryParams: {
            companyId,
          },
        },
  );
};
